import dark from './dark';
import light from './light';
import primary from './primary';
import secondary from './secondary';
import custom from './custom';

export default {
  dark,
  light,
  primary,
  secondary,
  custom,
};
